<div></div>
<div class="row">
  <div class="col">
    @if (isPopup) {
      <mat-form-field appearance="fill" style="width: 100%">
        <mat-label>{{ title }}</mat-label>
        <input
          matInput
          [id]="inputFieldId"
          [attr.data-testid]="inputFieldId"
          [formControl]="displayValue"
          [placeholder]="placeholder"
          [required]="required"
          [readonly]="true"
        (click)="
          !(setBtnLoading || disabled || readonly) ? onSetClicked() : null
        "
          />
          <button
            type="button"
            [id]="btnId"
            [attr.data-testid]="btnId"
            mat-button
            matSuffix
            class="btn-adjust__post-icon"
            (click)="onSetClicked()"
            [matTooltip]="'configuration-fields.set' | translate"
            [disabled]="disabled || readonly || setBtnLoading"
            id="configuration-fields-set-btn"
            >
            @if (setBtnLoading) {
              <mat-spinner
                diameter="25"
                style="top: 6px"
              ></mat-spinner>
            }
            @if (!setBtnLoading) {
              <div>
                {{ 'configuration-fields.set' | translate }}
              </div>
            }
          </button>
          @if (
            errorMessage &&
            !(
            displayValue.hasError('required') ||
            displayValue.hasError('whitespace')
            )
            ) {
            <mat-error
              >{{ errorMessage }}</mat-error
              >
          }
          @if (
            displayValue.hasError('required') ||
            displayValue.hasError('whitespace')
            ) {
            <mat-error
              >{{ title }}&nbsp;is required</mat-error
              >
            }
          </mat-form-field>
        }

        @if (!isPopup) {
          <el-inline-popup
            [data]="data"
            [noOfFields]="noOfFields"
            [popupConfig]="popupConfig"
            [isRequired]="required"
            (onSetValue)="onSetValue.emit($event)"
          ></el-inline-popup>
        }
      </div>
    </div>
